import React from 'react';
import s from './CollapseInfoItem.scss';
import classNames from 'classnames';
import {Cell} from '../../../../Layouts/Cell/Cell';
import {InfoSectionDescription} from '../../../InfoSectionDescription/InfoSectionDescription';
import {InfoSectionLayoutId, keyboardEvents} from '../../../../../constants';
import {InfoSectionTitle} from '../../../InfoSectionTitle/InfoSectionTitle';
import {MinusTabs, PlusTabs} from '../../../../../icons/dist';
import AnimateHeight from 'react-animate-height';
import {withGlobalProps, type ProvidedGlobalProps} from '../../../../../providers/globalPropsProvider';
import {SPECS} from '../../../../../specs';

export enum CollapseInfoItemDataHook {
  Root = 'collapse-info-item',
  Button = 'collapse-info-button',
  MinusIcon = 'collapse-info-minus-icon',
  PlusIcon = 'collapse-info-plus-icon',
}

export interface CollapseInfoItemProps extends ProvidedGlobalProps {
  description: string;
  index: number;
  title: string;
  isActive: boolean;

  handelToggleCollapse(index: number): void;
  onAnimationEnd(ref: React.RefObject<HTMLButtonElement>): void;
}

class CollapseInfoItemBase extends React.PureComponent<CollapseInfoItemProps> {
  private readonly collapseRef = React.createRef<HTMLButtonElement>();

  private readonly onToggleCollapse = () => {
    const {handelToggleCollapse, index} = this.props;
    handelToggleCollapse(index);
  };

  private readonly onKeypressToggleCollapse = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    /* istanbul ignore next: todo: keyCode is deprecated */
    if (e.keyCode === keyboardEvents.ENTER.keyCode) {
      this.onToggleCollapse();
    }
  };

  public render(): JSX.Element {
    const {description, title, isActive, index, onAnimationEnd, globals} = this.props;
    const legacyLists = !globals.useExperiments.enabled(SPECS.InfoSectionRicosGalleryListFix);
    const CollapseInfoItemClass = classNames(s.infoSectionCollapse, {
      [s.isActive]: isActive,
      [s.legacyLists]: legacyLists,
    });
    return (
      <li className={CollapseInfoItemClass} data-hook={CollapseInfoItemDataHook.Root}>
        <button
          type="button"
          ref={this.collapseRef}
          className={classNames(s.button, s.rtlAlignment)}
          aria-expanded={isActive}
          onClick={this.onToggleCollapse}
          onKeyPress={this.onKeypressToggleCollapse}
          data-hook={CollapseInfoItemDataHook.Button}>
          <InfoSectionTitle theme={InfoSectionLayoutId.Collapse} title={title} />
          {isActive ? (
            <Cell className={classNames(s.icon, s.iconRtlAlignment)} dataHook={CollapseInfoItemDataHook.MinusIcon}>
              <MinusTabs />
            </Cell>
          ) : (
            <Cell className={classNames(s.icon, s.iconRtlAlignment)} dataHook={CollapseInfoItemDataHook.PlusIcon}>
              <PlusTabs />
            </Cell>
          )}
        </button>
        <AnimateHeight
          easing="cubic-bezier(.39,.11,.37,.99)"
          duration={200}
          height={isActive ? 'auto' : 0}
          onAnimationEnd={/* istanbul ignore next: todo: test */ () => onAnimationEnd(this.collapseRef)}>
          <Cell className={s.description}>
            <InfoSectionDescription description={description} index={index} />
          </Cell>
        </AnimateHeight>
      </li>
    );
  }
}

export const CollapseInfoItem = withGlobalProps(CollapseInfoItemBase);
